import React, { Component } from "react";
import { Link } from "react-router-dom";

class KpiButton extends Component {
  render() {
    const { path, label } = this.props;

    return (
      // <Link to={`/stats/.../${pdcId}`}>
      <Link to={path} target="_blank">
        <span className={`p-btn p-btn-blue "p-mrg-left-s`}>{label}</span>
      </Link>
    );
  }
}

export default KpiButton;



// WEBPACK FOOTER //
// src/components/activite/buttons/KpiButton.js